import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { LogOut, Sparkles } from "lucide-react";
import LanguageSwitcher from "../shared/ui/LanguageSwitcher";
import SalesSidebar from "./SalesSidebar";

export default function SalesLayout({ authData, logout }) {
  const { t, i18n } = useTranslation();
  void i18n;

  return (
    <div className="relative min-h-screen text-white overflow-hidden">
      {/* نفس خلفية الفيديو */}
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover">
        <source src="/login-bg.mp4" type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-purple-900/40 to-black/80" />

      <div className="relative z-10">
        {/* Topbar */}
        <div className="backdrop-blur-xl bg-white/10 border-b border-white/20 shadow-[0_0_25px_rgba(255,0,255,0.25)]">
          <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Sparkles className="w-7 h-7 text-pink-300 drop-shadow-lg" />
              <div>
                <div className="text-lg font-bold">{t("sales.layout.title")}</div>
                <div className="text-xs text-white/70">
                  {authData?.fullName || authData?.email || t("sales.layout.userFallback")} —{" "}
                  {authData?.role}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <LanguageSwitcher />
              <button
                onClick={logout}
                className="py-2 px-4 rounded-xl text-white font-semibold bg-gradient-to-r from-pink-500 to-red-500 hover:opacity-90 transition flex items-center gap-2"
              >
                <LogOut className="w-5 h-5" />
                {t("common.logout")}
              </button>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="max-w-7xl mx-auto p-6 pt-8">
          <div className="flex flex-col lg:flex-row gap-6">
            <SalesSidebar />

            <main className="flex-1">
              {/* حاوية المحتوى */}
              <div className="backdrop-blur-2xl bg-white/10 border border-white/20 rounded-2xl p-4 shadow-[0_0_35px_rgba(255,0,255,0.14)]">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
